export default function OutlineTitle({ children, testId, className = "" }) {
  return (
    <h1
      data-testid={testId}
      className={`inline-flex items-center rounded-xl border-[3px] border-primary px-5 py-2.5 font-display text-[1.7rem] font-bold uppercase leading-none ${className}`}
    >
      <span className="translate-y-[1px]">{children}</span>
    </h1>
  );
}
